// Десктоп: наведение на карточку или на номер в иллюстрации подсвечивает карточку и меняет картинку
export default function enterpriseChecks() {
  const desktop = window.matchMedia('(min-width: 769px) and (hover: hover)');

  document.querySelectorAll('[data-checks]').forEach((root) => {
    const targets = root.querySelectorAll('[data-check-card], [data-check-hotspot]');

    const setActive = (value) => {
      if (value && desktop.matches) root.dataset.active = value;
      else delete root.dataset.active;
    };

    targets.forEach((target) => {
      const value = target.dataset.checkCard || target.dataset.checkHotspot;
      target.addEventListener('mouseenter', () => setActive(value));
      target.addEventListener('mouseleave', () => setActive(null));
    });

    desktop.addEventListener('change', () => setActive(null));
  });
}
